export const WHATSAPP_PHONE = "918758379686";

export const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hi PyCray, I'd like to explore AI for my business"
);

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${WHATSAPP_MESSAGE}`;
